/* eslint-disable no-param-reassign -- Redux Toolkit uses Immer */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { BUILDER_ACCESS_STATES } from '../constants';
import { type BuilderAccessStateTypes } from '../types';

export interface GlobalState {
  builderAccessState: BuilderAccessStateTypes;
}

const initialState: GlobalState = {
  builderAccessState: BUILDER_ACCESS_STATES.EDIT,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setBuilderAccessState(
      state,
      action: PayloadAction<BuilderAccessStateTypes>
    ) {
      state.builderAccessState = action.payload;
    },
    resetGlobal() {
      return initialState;
    },
  },
});

/** Unified actions export for this slice (mirrors management) */
export const globalActions = globalSlice.actions;

/** Reducer exports (both default and named for convenience) */
export const globalReducer = globalSlice.reducer;
export default globalSlice.reducer;
